import { useRouter } from 'next/router';
import { Fragment } from 'react';

const Tags = ({ tags }) => {
  const router = useRouter();

  const onChipClick = (event, category) => {
    if (typeof window !== 'undefined') {
      // localStorage.setItem('name', category[0]['name'])
      if (window.location.pathname !== '/resources') {
        // router.push('/resources');
        router.push({
          pathname: '/resources',
          query: { category: category[0]['name'].toLowerCase() },
        });
      }
    }
  };

  const renderCategories = () => {
    return tags.map((item, index) => {
      if (index % 3 === 0 && index !== 0) {
        return (
          <Fragment key={`tag-${item?.name || index}`}>
            <div style={{ width: '100%' }} />
            <div
              className="div-tags-link pill"
              onClick={(event) => onChipClick(event, [{ name: item?.field_source_translation }])}
            >
              {item?.name}
            </div>
          </Fragment>
        );
      } else {
        return (
          <div
            key={`tag-${item?.name || index}`}
            className="div-tags-link pill"
            onClick={(event) => onChipClick(event, [{ name: item?.field_source_translation }])}
          >
            {item?.name}
          </div>
        );
      }
    });
  };

  if (tags.length === 0) {
    return '';
  }

  return (
    <div className="resources-tags">
      <div className="tag">Tags</div>
      <div className="pills">{renderCategories()}</div>
    </div>
  );
};
export default Tags;
